import { useMarketFeedStore } from '@/stores/marketFeed.js';
import { useExploreFeedStore } from '@/stores/exploreFeed.js';
import { useWatchlistFeedStore } from '@/stores/watchlistFeed.js';
import { useCryptoFeedStore } from '@/stores/cryptoFeed.js';
import { useSportFeedStore } from '@/stores/sportFeed.js';
import { clearFeedCardsCache } from '@/modules/market-feed/presentation/useMarketFeedPresentation.js';
import { clearAllFeedScrollAnchors } from '@/composables/useFeedScrollContext.js';

/**
 * 主动登出 / 会话失效：仅清用户相关 Feed。
 * 首页、探索为公开 collection/page，登出后游客应继续看到列表，不可 $reset 导致 keep-alive 页空白。
 * 收藏 ID 由 useMarketWatchlist 的 subscribeAuthState 同步清空。
 */
export function resetUserFeedOnLogout() {
  useWatchlistFeedStore().$reset();
}

/**
 * 换号登录等场景：清空全部 Feed、展示缓存与 scroll anchors，避免跨账号残留。
 */
export function resetAllFeedStores() {
  const marketFeed = useMarketFeedStore();
  marketFeed.disposeSearchTimer();
  marketFeed.$reset();
  clearFeedCardsCache();
  clearAllFeedScrollAnchors();

  useExploreFeedStore().$reset();
  useWatchlistFeedStore().$reset();
  useCryptoFeedStore().$reset();
  useSportFeedStore().$reset();
}

/** @deprecated 使用 resetUserFeedOnLogout / resetAllFeedStores */
export function resetFeedStores() {
  resetAllFeedStores();
}
